module.exports = __webpack_public_path__ + "img/152.05830695.jpg";